import React from 'react';
import { RiBankLine } from "react-icons/ri"; // Assurez-vous d'avoir 'react-icons' installé
import transactionData from './transactionData2.json';
import { FaAlipay } from "react-icons/fa";
import './TransactionCard2.scss';

const TransactionCard = () => {
    const transaction = transactionData
  return (
    <div className="transaction-card">
      <div className="row">
        <div className="icon"><RiBankLine /></div>
        <div className="text">{transaction.timestamp}</div>
        <div >{transaction.paymentDetails.totalAmount}</div>
      </div>      
      <div className="row">
        <div className="amount-small">{transaction.paymentDetails.amount}</div>
        <div className="confirmation">{transaction.paymentDetails.confirmation}</div>
      </div>
      <div className="row">
        <div className="status-description">{transaction.statusDescription}</div>
        <div className="empty"></div>
      </div>
      <div className="row">
        <div className="method"><FaAlipay className='fa' /> {transaction.paymentDetails.method}</div>
        <button className="action">account</button>
      </div>      
    </div>
  );
};

export default TransactionCard;
